import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import {
  GetGroupsRequest,
  GetGroupsResponse,
  Group,
  SaveGroupRequest,
  SaveGroupResponse,
  UpdatePositionRequest,
} from '@models'

@Injectable({
  providedIn: 'root',
})
export class GroupService {
  private readonly baseUrl = `${environment.api.baseUrl}/product-structure/v1/groups`

  constructor(private http: HttpClient) {}

  async getAll(params?: GetGroupsRequest): Promise<GetGroupsResponse> {
    let httpParams = new HttpParams()

    if (params) {
      if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString())

      if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize.toString())

      if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)

      if (params.order) httpParams = httpParams.set('order', params.order)

      if (params.name) httpParams = httpParams.set('name', params.name)
    }

    const response = await firstValueFrom(this.http.get<GetGroupsResponse>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<Group> {
    const response = await firstValueFrom(this.http.get<Group>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: SaveGroupRequest): Promise<SaveGroupResponse> {
    const response = await firstValueFrom(this.http.post<SaveGroupResponse>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: SaveGroupRequest): Promise<SaveGroupResponse> {
    const response = await firstValueFrom(this.http.put<SaveGroupResponse>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }

  async updatePosition(payload: UpdatePositionRequest[]): Promise<void> {
    const response = await firstValueFrom(this.http.patch<void>(`${this.baseUrl}/position`, payload))
    return response
  }
}
